var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"mx-auto",class:[_vm.size]})
}
var staticRenderFns = []

export { render, staticRenderFns }